<template>
  <div id="main">
    <div class="header" :style="styleObject">
      <div class="wrap" style="display: flex; align-items: center">
        <img class="logo-init" src="../images/晨鸟log.png"   @click="goHome"/>

        <ul class="custom-menu">
  <li
    v-for="item in title"
    :key="item.value"
    @mouseenter="handleMouseEnter(item)"
    @mouseleave="handleMouseLeave()"
    :class="{ 'education-product': item.lable === '教育产品' }"
    @click.stop="selectTitle(item)" 
  >
    <div>
      <a
        :title="item.lable"
        :class="['nav-a', { active: isDropdownVisible && item.lable === '教育产品' }, item.lable === '教育产品' ? 'arrow' : '']">
        {{ item.lable }}
      </a>
    </div>
    <div
      v-show="currentHover === '教育产品' && isDropdownVisible"
      class="dropdown-menu"
    >
      <div class="dropdown-items">
        <div
          v-for="category in dropdownOptions"
          :key="category.title"
          class="category-wrapper"
        >
          <div class="category-title" >{{ category.title }}</div>
          <div class="vertical-line"></div>
          <div class="subcategory-items">
            <div
              v-for="subItem in category.items"
              :key="subItem.name"
              class="subcategory-item"
            >
              <router-link :to="subItem.link" class="subcategory-link" @click.stop>{{ subItem.name }}</router-link>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="selecttitle == item.lable" class="custom_border"></div>
  </li>
</ul>
       
      </div>
    </div>

    <div>
      <router-view />
    </div>
    <div class="main-bottom">
      <div class="wrap" style="display: flex">
        <div class="router">
          <div class="bottom_module">
            <div class="bottom_title">教育产品</div>
            <div class="bottom_border">
              <div class="bottom_border_1"></div>
              <div class="bottom_border_2"></div>
            </div>
            <!-- <a href="/EducationalProducts#Simulate" class="bottom_p">仿真博弈沙盘产品</a> -->
            <router-link to="/EducationalProducts#Simulate" class="bottom_p" @click="goToEducational">仿真博弈平台</router-link>
            <router-link to="/EducationalProducts#innovation" class="bottom_p" @click="goToEducational2">创新创业产品</router-link>
            <router-link to="/EducationalProducts#enabling" class="bottom_p" @click="goToEducational3">赋能产品</router-link>
            <!-- <a href="/EducationalProducts#innovation" class="bottom_p">创新创业产品</a>
            <a href="/EducationalProducts#enabling" class="bottom_p">赋能产品</a> -->
          </div>
          <div class="bottom_module">
            <div class="bottom_title">产品优势</div>
            <div class="bottom_border">
              <div class="bottom_border_1"></div>
              <div class="bottom_border_2"></div>
            </div>
            <router-link to="/#advance" class="bottom_p">严肃游戏教学</router-link>
            <router-link to="/#advance" class="bottom_p" >沉浸互动教学</router-link>
            <router-link to="/#advance" class="bottom_p" >前沿技能赋能</router-link>
           
            <!-- <a href="/#advance" class="bottom_p">严肃游戏教学</a>
            <a href="/#advance" class="bottom_p">沉浸互动教学</a>
            <a href="/#advance" class="bottom_p">前沿技能赋能</a> -->
          </div>
          <div class="bottom_module">
            <div class="bottom_title">合作生态</div>
            <div class="bottom_border">
              <div class="bottom_border_1"></div>
              <div class="bottom_border_2"></div>
            </div>
            <router-link to="/ModelCase#benke" class="bottom_p" @click="goToModelCase">本科院校</router-link>
            <router-link to="/ModelCase#gaozhi" class="bottom_p" @click="goToModelCase2">高职中专</router-link>
            <router-link to="/ChannelCooperation" class="bottom_p">渠道合作</router-link>
            <!-- <a href="/ModelCase#benke" class="bottom_p">本科院校</a>
            <a href="/ModelCase#gaozhi" class="bottom_p">高职中专</a>
            <a href="/ChannelCooperation" class="bottom_p">渠道合作</a> -->
          </div>
          <div class="bottom_module">
            <div class="bottom_title">公司动态</div>
            <div class="bottom_border">
              <div class="bottom_border_1"></div>
              <div class="bottom_border_2"></div>
            </div>
            <!-- <a href="/News" class="bottom_p">新闻动态</a> -->
            <router-link to="/News" class="bottom_p">新闻动态</router-link>
            <router-link to="/SkillsCompetitionList" class="bottom_p">技能竞赛</router-link>
            <router-link to="/Meeting" class="bottom_p">会议</router-link>
            <!-- <a href="/SkillsCompetitionList" class="bottom_p">技能竞赛</a>
            <a href="/Meeting" class="bottom_p">会议</a> -->
          </div>
        </div>
        <div style="display: flex; align-items: center">
          <div style="border: 1px solid; height: 60%"></div>
        </div>
        <div class="contact">
          <div class="bottom_module">
            <div class="bottom_title">联系我们</div>
            <div class="bottom_border">
              <div class="bottom_border_1"></div>
              <div class="bottom_border_2"></div>
            </div>
            <div
              class="contact-info"
              style="display: flex; align-items: center"
            >
              <div class="contact-item wechat-item">
                <span>400-820-3886</span>
              </div>
              <div class="contact-item email-item">
                <span>zhouyujie@chenniao.com</span>
              </div>
            </div>
            

            <div class="contact-image-container">
              <div
                class="contact-image"
                style="margin-left: auto; margin-right: auto"
              ></div>
              <div class="additional-text">公众号二维码</div>

            </div>

            <div class="contact2-image-container">
              <div
                class="contact2-image"
                style="margin-left: auto; margin-right: auto"
              ></div>
              <div class="additional2-text">孙老师</div>

            </div>

          </div>
        </div>
      </div>
    </div>
    <div class="copyright-box">
      <div class="copyright">
        Copyright ©2004-{{ currentYear }} 晨鸟科技 版权所有
        <a href="https://beian.miit.gov.cn" target="_blank"
          >沪ICP备09012675号-1</a
        >
        <a
          href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=31011502014082"
          target="_blank"
          >沪公网安备31011502014082号</a
        >
        <br />
        地址: 上海市杨浦区国权北路1688弄A6座9楼
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src

export default {
  data() {
    return {
      currentYear: 0,
      title: [
        { value: "/", lable: "首页" },
        { value: "/EducationalProducts", lable: "教育产品" },
        { value: "/SkillsCompetitionList", lable: "技能竞赛" },
        { value: "/ModelCase", lable: "样板案例" },
        { value: "/CollaborativeEducationList", lable: "协同育人" },
        { value: "/Meeting", lable: "会议" },
        { value: "/News", lable: "新闻动态" },
        { value: "/ChannelCooperation", lable: "渠道合作" },
        { value: "/AboutUs", lable: "关于我们" },
        { value: "http://report.chenniao.com/", lable: "日报管理", external: true },
      ],
      selecttitle: "首页",
      currentHover: "",
      isDropdownVisible: false,
      styleObject: {}, // 用于动态绑定样式的变量

      //下拉菜单框
      dropdownOptions: [
        {
          title: "基于大语言模型营运管理仿真博弈平台",
          items: [
          {
              name: "基于大模型的数字旅游营运管理仿真博弈平台(沙盘版/PC 版)",
              link: "/Tourism",
            },
            {
              name: "基于大模型的康养营运管理仿真博弈平台(沙盘版/PC 版)",
              link: "/Health",
            },
            {
              name: "基于大模型的民宿运营管理仿真博弈平台(沙盘版/PC 版)",
              link: "/Homestay",
            },
            {
              name: "基于大模型的物流管理营运仿真博弈平台(沙盘版/PC 版)",
              link: "/Logistics",
            },
            {
              name: "基于大模型的电子商务营运仿真博弈平台(沙盘版/PC 版)",
              link: "/Ecommerce",
            },
            {
              name: "基于大模型的研学旅行运营管理仿真博弈平台(沙盘版/PC 版)",
              link: "/StudyTravel",
            },
            {
              name: "基于大模型的跨境电子商务营运仿真博弈平台(沙盘版/PC 版)",
              link: "/CrossBorder",
            },
            {
              name: "基于大模型的酒店数智化营运管理仿真博弈平台(沙盘版/PC 版)",
              link: "/Hotel",
            },
            {
              name: "基于大模型的会展数字化运营管理仿真博弈平台(沙盘版/PC 版)",
              link: "/Exhibition",
            },
            {
              name: "基于大模型的餐饮数字化运营管理仿真博弈平台(沙盘版/PC 版)",
              link: "/Catering",
            },
            {
              name: "基于大模型的区块链供应链金融营运仿真博弈平台(沙盘版/PC 版)",
              link: "/Blockchain",
            },
          ],
        },
        {
          title: "创新创业产品",
          items: [
            { name: "大学生创新创业实践平台", link: "/entrepreneurship" },
            { name: "数字旅游创业实践平台", link: "/DigitalTtourism"},
            { name: "移动应用创新实践平台", link: "/MobileApplication"},
          ],
        },
        {
          title: "赋能&其它产品",
          items: [
          {
              name: "智能答题助手",
              link: "/AI",
            },
            { name: "数字助教情感识别系统", link: "/DigitalTeaching"},
            {
              name: "区块链酒店数字化接待系统",
              link: "/BlockchainHotel",
            },
            {
              name: "数字化竞赛区块链及可视化系统",
              link: "/DigitalCompetition",
            },
          ],
        },
      ],
    };
  },
  created() {
    this.currentYear = new Date().getFullYear();
    document.title = "晨鸟科技官网-AI-自主创新、至于至善-数字教育服务专家"; 
  },

  methods: {
    goToModelCase(){
      this.$router.push('/ModelCase').then(() => {
        window.scrollTo({ top: document.getElementById('benke').offsetTop, behavior: 'smooth' });
      });
    },
    goToModelCase2(){
      this.$router.push('/ModelCase').then(() => {
        window.scrollTo({ top: document.getElementById('gaozhi').offsetTop, behavior: 'smooth' });
      });
    },
    goToEducational(){
      this.$router.push('/EducationalProducts').then(() => {
        window.scrollTo({ top: document.getElementById('Simulate').offsetTop, behavior: 'smooth' });
      });
    },
    goToEducational2(){
      this.$router.push('/EducationalProducts').then(() => {
        window.scrollTo({ top: document.getElementById('innovation').offsetTop, behavior: 'smooth' });
      });
    },
    goToEducational3(){
      this.$router.push('/EducationalProducts').then(() => {
        window.scrollTo({ top: document.getElementById('enabling').offsetTop, behavior: 'smooth' });
      });
    },
    goHome() {
    this.$router.push('/');
    document.title = "晨鸟科技官网-AI-自主创新、至于至善-数字教育服务专家"; // 更新浏览器标题
  },
  // selectTitle(item) {
  //   this.selecttitle = item.lable;
  //   this.$router.push(item.value);
  // },
   selectTitle(item) {
    if (item.external) {
      // 打开新标签页跳转
      window.open(item.value, '_blank');
    } else {
      this.selecttitle = item.lable;
      this.$router.push(item.value);
    }
  },

    handleMouseEnter(item) {
      if (item.lable === "教育产品") {
        this.isDropdownVisible = true;
        this.currentHover = item.lable;
        this.preventScroll(); // 阻止页面滚动
      }
    },

    handleMouseLeave() {
      this.isDropdownVisible = false;
      this.currentHover = "";
      this.allowScroll(); // 允许页面滚动
    },

    preventScroll() {
      // 阻止页面主体滚动
      document.body.style.overflow = "hidden";
    },
    allowScroll() {
      // 允许页面主体滚动
      document.body.style.overflow = "";
    },
    handleScroll(event) {
      // 阻止滚动事件
      event.preventDefault();
    },
    updateDocumentTitle(desc = '') {
     
    if (this.selecttitle === "教育产品") {
      document.title = "晨鸟出品、必属精品-精益求精的数字教育产品"; 
    } else if(this.selecttitle === "技能竞赛"){
       document.title = "承办、支持各类技能大赛（高职、本科）-以赛促教、以赛促学-晨鸟科技"
    }else if(this.selecttitle === "样板案例"){
        document.title = "数字教育产品服务500多所高校-支持实验实训教学-赋能专升本、精品课程、双高申请-晨鸟科技"
    }else if(this.selecttitle === "协同育人"){
       document.title = "教育部产学合作协同育人项目-数字教育专家-晨鸟科技"
    }else if(this.selecttitle === "会议"){
        document.title = "承办、支持学术会议和高峰论坛-数字教育专家-晨鸟科技"
    }else if(this.selecttitle === "新闻动态"){
        document.title = "新闻动态-数字教育专家-晨鸟科技"
    }else if(this.selecttitle === "渠道合作"){
        document.title = "渠道合作-数字教育专家-晨鸟科技"
    }else if(this.selecttitle === "关于我们"){
        document.title = "晨鸟科技-自主创新、至于至善-数字教育服务专家"
    }else if(this.selecttitle === "首页"){
       document.title = "晨鸟科技官网-AI-自主创新、至于至善-数字教育服务专家"
    }
    else {
      document.title = "晨鸟科技-自主创新、至于至善-数字教育服务专家";
    }
  },
  },
  watch: {
  '$route'(to, from) {
    const currentTitle = this.title.find(item => item.value === to.path)?.lable;
    if (currentTitle) {
      this.selecttitle = currentTitle;
      localStorage.setItem('selectedTitle', currentTitle);
      this.updateDocumentTitle();
      
    }
  }
},
  mounted() {
  const storedTitle = localStorage.getItem('selectedTitle');
  const currentRouteTitle = this.$route.path;
  const currentTitle = this.title.find(item => item.value === currentRouteTitle)?.lable;
  
  if (storedTitle && storedTitle !== currentTitle) {
    this.selecttitle = currentTitle || storedTitle;
    localStorage.setItem('selectedTitle', this.selecttitle);
  } else {
    this.selecttitle = currentTitle || storedTitle || this.title[0]?.lable; // 默认选中第一个标题
  }

  this.updateDocumentTitle();

  this.$nextTick(() => {
    const hash = this.$route.hash;
    if (hash) {
      const element = this.$el.querySelector(hash);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    }
  });
}

};
</script>
<style>
.wrap {
  position: relative;
  width: 1100px;
  margin: 0 auto;
}
</style>
<style scoped>
/* .header {
  z-index: 99;
  width: 100%;
  height: 80px;
  top: 0;
  background: #fff;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  align-content: center;
} */

.header {
  z-index: 100;
  width: 100%;
  height: 80px;
  position: fixed; 
  top: 0;
  left: 0;
  background: #fff;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  display: flex; 
  justify-content: center; 
  align-items: center; 
}

.custom-menu {
  list-style-type: none;
  flex: 1;
  display: flex;
  justify-content: flex-end;
  cursor: pointer;
}

.custom-menu li {
  position: relative;
  margin: 0 0 0 39px;
}

.custom_border {
  margin-top: 5px;
  border-bottom: 3px solid #ff6b3d;
  border-radius: 5px;
}

.nav-a {
  color: #444;
  text-decoration: none;
  white-space: nowrap;
  display: inline-block;
  position: relative;
  transition: color 0.3s;
}

.nav-a:hover {
  color: #ff8a00;
}

.arrow::after {
  content: "";
  position: absolute;
  top: 50%;
  right: -15px;
  width: 0;
  height: 0;
  border-left: 5px solid transparent;
  border-right: 5px solid transparent;
  border-bottom: 5px solid #000;
  margin-top: -2px;
  transition: transform 0.3s;
}

.arrow:hover::after {
  transform: rotate(180deg);
}

#main {
  width: 100%;
  height: 100%;
}

.logo-init {
  width: 128px;
  cursor: pointer;
}

.main-bottom {
  background: #1f1f37;
  background-repeat: no-repeat;
  width: 100%;
  height: 400px;
  display: flex;
  justify-content: space-around;
}

.bottom_title {
  color: #f8f8f8;
  font-size: 16px;
}

.bottom_p {
  color: #848383;
  font-size: 12px;
  text-decoration: none;
  transition: color 0.3s;
}

.bottom_p:hover {
  color: #ff8a00;
}

.router {
  display: flex;
  width: 600px;
  margin-top: 5%;
  justify-content: center;
  margin-left: -30px;
}

.bottom_module {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  line-height: 50px;
  width: 130px;
  margin-bottom: 0;
}

.bottom_border {
  display: flex;
  align-items: center;
  margin-bottom: 15px;
}

.bottom_border_1 {
  width: 25px;
  height: 5px;
  background: green;
}

.bottom_border_2 {
  width: 40px;
  height: 2px;
  background: #f2f3f5;
}

.contact {
  flex: 1;
  margin-left: 6%;
  margin-top: 5%;
  width: 600px;
}

.copyright-box {
  background: #000000;
  color: white;
  height: 120px;
  font-size: 14px;
}

.copyright {
  width: 1100px;
  height: 60px;
  margin: 0 auto;
  line-height: 60px;
  color: #777;
  white-space: nowrap;
}

.copyright a {
  color: #777;
  text-decoration: none;
}

.copyright a:hover {
  color: white;
  text-decoration: underline;
}

.bottom_information {
  color: #fff;
  font-size: 18px;
  margin-left: 20px;
  margin-right: 40px;
}

.contact-info {
  display: inline-flex;
  align-items: center;
  margin-top: 10px;
}

.contact-item {
  white-space: nowrap;
  margin-right: 20px;
  display: flex;
  align-items: center;
  position: relative;
  padding-left: 24px;
  margin-bottom: 10px;
}

.contact-item:not(:last-child) {
  margin-right: 50px;
}

.contact-item span {
  color: #fff;
  font-size: 14px;
  padding-left: 8px;
  font-weight: 400;
}

/* 微信图标样式 */
.wechat-item {
  /* background-image: url("/src/images/Ima/Group\ 56.png"); */
  background-image: url("/src/images/potato/电话图标.png");
  background-size: 16px 16px;
  background-repeat: no-repeat;
  background-position: left center;
}

/* 邮箱图标样式 */
.email-item {
  /* background-image: url("/src/images/Ima/邮箱.png"); */
  background-image: url("/src/images/potato/邮箱.png");
  background-size: 16px 16px;
  background-repeat: no-repeat;
  background-position: left center;
}

.contact-image {
  width: 100px;
  height: 100px;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  background-image: url("/src/images/Ima/微信图片_20240729134326.jpg");
}

.contact-image-container {
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}
.contact2-image-container {
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction:column;
  margin-left: 210px;
  margin-top: -150px;
}
.additional2-text {
  margin-top: 0px;
  text-align: center;
  color: #c7c7cd;
  font-size: 14px;
  font-weight: 400;
}

.additional-text {
  margin-top: 0px;
  text-align: center;
  color: #c7c7cd;
  font-size: 14px;
  font-weight: 400;
}



.dropdown-menu {
  display: none;
  flex-direction: column;
  position: fixed;
  top: 54px;
  left: 0;
  right: 0;
  width: 100%;
  max-height: 400px; /* 设置最大高度 */
  background: #fff;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  padding: 10px 0;
  z-index: 5000 !important;
  overflow-y: auto; /* 内容超出时显示垂直滚动条 */
  overflow-x: hidden; /* 隐藏水平滚动条 */
}


.dropdown-items {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: flex-start;
  width: 100%;
  padding: 0 20px;
  z-index: 5000;
  z-index: 5000 !important;
}

.dropdown-item {
  flex: 1 1 auto;
  text-align: center;
  padding: 10px;
  cursor: pointer;
  box-sizing: border-box;
  max-width: calc(100% / 3);
  width: 33%;
  margin-top: 20px;
  position: relative;
  padding-bottom: 10px;
  z-index: 5000 !important;
}

.dropdown-item::after {
  content: "";
  display: block;
  height: 1px;
  width: 50%;
  background-color: #f9f9f9;
  margin-left: 150px;
  margin-top: 15px;
}

.dropdown-menu.show {
  display: block;
}

.dropdown-menu[style*="display: block;"] {
  display: block !important;
}

.custom-menu li:hover .dropdown-menu {
  display: block;
}

.education-product:hover .dropdown-menu {
  display: block;
}

.category-wrapper {
  /* 平均分配宽度，后续单独调整第一个分类 */
  flex: 1; 
  margin: 0 20px;
  text-align: left;
}

/* 单独调整第一个分类，即仿真博弈沙盘产品 */
.category-wrapper:nth-child(1) {
  /* 让第一个分类占比更大，可按需调整 */
  flex: 1.5; 
}

.category-title {
  margin-top: 30px;
  font-size: 18px;
  font-weight: bold;
  margin-bottom: 20px;
  text-align: left;
  margin-left: 16px;
}

.subcategory-items {
  padding: 0 20px;
  line-height: 1rem
}

.subcategory-item {
  padding: 5px 0;
  text-align: left;
}
.nav-a.active {
  color: #ff8a00; 
}

.arrow.active::after {
  border-bottom-color: #ff8a00; 
  transform: rotate(180deg); 
}

.subcategory-link {
  color: #000000;
  text-decoration: none;
}

.subcategory-link:hover {
  text-decoration: none;
  color: #ff8a00;
}

/* .category-title::after {
  content: "";
  display: block;
  height: 1px;
  width: 30%;
  margin: 10px auto 10px;
  background-color: #f7f7f7;
  border-radius: 1px;
} */

.custom-menu li.education-product:before,
.custom-menu li.education-product:after {
  content: "";
  position: absolute;
  height: 100%;
  background: transparent;
  z-index: 1;
}

.custom-menu li.education-product:before {
  left: 60px;
  width: 50px;
}
.contact2-image{
    background-image: url('/src/images/potato/微信二维码.png');
    width: 100px;
    height: 100px;
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
}

/* .vertical-line {
  width: 1px;
  height: 100px;
  background-color: red; 
} */

</style>
